import React from 'react';
import {
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  FormControl,
} from '@mui/material';
import Header from 'components/header/header';
import Button from 'ui-components/button';
import { useHistory } from "react-router-dom";

const Registration = ({
  classes,
  handleFirstNameChange,
  handleLastNameChange,
  handleEmailChange,
  handlePasswordChange,
  handleRegistrationSubmit,
  handlePasswordConfirmationChange,
  handleGenderChange,
  handleProfessionChange,
  gender,
  professions,
  professionId,
}) => {
  const professionItems = professions.map(profession => (
    <MenuItem key={profession.id} value={profession.id}>
      {profession.name}
    </MenuItem>
  ));
  const history = useHistory();

  return (
    <>
    <Header title={'Registrieren'} />
    <div className="login-registration-box">
      <div className="login-registration-box-gender">
        <FormControlLabel
          value="female"
          control={<Radio />}
          label="Frau"
          onChange={handleGenderChange}
        />
        <FormControlLabel
          value="male"
          control={<Radio />}
          label="Herr"
          onChange={handleGenderChange}
        />
        <FormControlLabel
          value="divers"
          control={<Radio />}
          label="Divers"
          onChange={handleGenderChange}
        />
      </div>
      <div className="login-registration-box-inputs">
        <input
          label="Vorname"
          name="firstName"
          placeholder="Vorname"
          className="login-box-input"
          onChange={handleFirstNameChange}
        />

        <input
          label="Nachname"
          name="lastName"
          placeholder="Nachname"
          className="login-box-input"
          onChange={handleLastNameChange}
        />

        <input
          label="E-Mail"
          name="email"
          placeholder="E-Mail"
          className="login-box-input"
          onChange={handleEmailChange}
        />    

        <input
          label="Passwort"
          name="password"
          placeholder="Passwort"
          type="password"
          className="login-box-input"
          onChange={handlePasswordChange}
        />

        <input
          label="Passwort Bestätigung"
          name="password_confirmation"
          placeholder="Passwort Bestätigung"
          type="password"
          className="login-box-input"
          onChange={handlePasswordConfirmationChange}
        />      

        <FormControl className="login-registration-box-form">
          <Select
            value={professionId}
            className="login-registration-box-select"
            onChange={handleProfessionChange}
            displayEmpty
          >
            <MenuItem value="" disabled>
              <div>Beruf</div>
            </MenuItem>
            {professionItems}
          </Select>
        </FormControl>

        <div className="login-registration-box-text">
          Mit der Registrierung akzeptierst du die 
          <span className="clickable-text" onClick={() => history.push('/agb')}>AGBs,</span> 
          <span className="clickable-text" onClick={() => history.push('/rules')}>Teilnahmebedingungen,</span> 
           und die 
          <span className="clickable-text" onClick={() => history.push('/data-protection')}>Datenschutzerklärung.</span>
        </div>

        <Button
          onClick={handleRegistrationSubmit}
        >
          REGISTRIEREN
        </Button>
      </div>
    </div>
    </>
  );
};

export default Registration;
